﻿window.addEventListener("DOMContentLoaded", function() {
    //fix for cases when $ is undefined while jquery is present on a page
    if (window.$ === undefined) {
        window.$ = jQuery
    }
    // Ask Al if want to make div html text blank, since international would understand just blank spinner.
    $('div#veSpinnerContainer').each(function(index) {
        var containerSelector = $(this);
        if (containerSelector.find('#loading').length === 0) {
            containerSelector.append('<div id="loading"><div id="loadingcontent"><p id="loadingspinner"></p></div></div>');
        }
    });

    $('div#veLoginSpinnerContainer').each(function (index) {
        var containerSelector = $(this);
        if (containerSelector.find('#loading').length === 0) {
            containerSelector.append('<div id="loading"><div id="loadingcontent"><p id="loadingspinner"></p></div></div>');
        }
    });

    $('div#veWebinarSpinnerContainer').each(function (index) {
        var containerSelector = $(this);
        if (containerSelector.find('#loading').length === 0) {
            containerSelector.append('<div id="loading"><div id="loadingcontent"><p id="loadingspinner"></p></div></div>');
        }
    });

    //If the viewport wide version of the spinner exists, create spinner animation and hide it.
    doSpinnerBySelector($('#viewport-wide-spinner'), null, 'loading');
    $('#viewport-wide-spinner:not(.dont-hide-default)').hide();
});

window.doSpinnerBySelector = function(selector, eventType, loadingDivId) {
    //If the viewport wide version of the spinner exists, show it.
    $('#viewport-wide-spinner, #viewport-wide-spinner #loading').show();

    if (!selector) {
        selector = $("#veSpinnerContainer");
    }

    if (!loadingDivId) {
        loadingDivId = 'loading';
    }

    if (hasActiveSpinner(selector, loadingDivId)) {
        return null;
    }

    if (eventType === "blur" || eventType === "change") {
        selector.attr('disabled', 'disabled');
    }
    //If want to change the text below the spinning div.
    //if (progressText != undefined) { $("#loadingspinner").html(progressText); }
    var target = selector.find('#' + loadingDivId);
    target.fadeIn();
    
    var opts = {
        lines: 12, // The number of lines to draw
        length: 7, // The length of each line
        width: 4, // The line thickness
        radius: 10, // The radius of the inner circle
        color: '#000', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false // Whether to use hardware acceleration
    };

    var spinner = new Spinner(opts).spin(target[0]);
    return spinner;
}

window.hasActiveSpinner = function(selector, loadingDivId) {
    return selector.find('#' + loadingDivId + ' > .spinner').length > 0;
}

// backwards compatibility
window.doSpinnerByLoadingId = function(id, eventType, loadingDivId) {
    if (!id) {
        doSpinnerBySelector(null, eventType, loadingDivId);
    }

    doSpinnerBySelector($("#" + id), eventType, loadingDivId);
}

// backwards compatibility
window.doSpinner = function(id, eventType) {
    doSpinnerByLoadingId(id, eventType, 'loading');
}

window.stopSpinnerBySelector = function(spinner, selector, loadingDivId) {
    //If the viewport wide version of the spinner exists, hide it.
    $('#viewport-wide-spinner').hide();

    if (!selector) {
        selector = $("#veSpinnerContainer");
    }

    if (!loadingDivId) {
        loadingDivId = 'loading';
    }

    var target = selector.find('#' + loadingDivId);
    target.data('spinner', spinner);
    target.fadeOut();
    selector.removeAttr("disabled");
}

// backwards compatibility
window.stopSpinnerByLoadingId = function(spinner, id, loadingDivId) {
    if (!id) {
        stopSpinnerBySelector(spinner, null, loadingDivId);
    }

    stopSpinnerBySelector(spinner, $("#" + id), loadingDivId);
}

// backwards compatibility
window.stopSpinner = function(spinner, id) {
    stopSpinnerByLoadingId(spinner, id, 'loading');
}

window.getSpinnerContainerSelector = function(targetForm) {
    var formContainer = $(targetForm).closest('.subscribe-block__content');
    if (formContainer.length === 0) {
        return $(targetForm).find('#veSpinnerContainer');
    } else {
        return formContainer.find('> #veSpinnerContainer');
    }
}

if (typeof $$epiforms !== 'undefined') {

    epi.EPiServer.Forms.AsyncSubmit = true;

    $$epiforms(document).ready(function myfunction() {
        var spinner;
        // listen to event when form is about submitting
        $$epiforms(".spinner-form").on("formsStartSubmitting", function (data) {
            spinner = doSpinnerBySelector(getSpinnerContainerSelector(data.target), null);
        });

        // listen to event when form is successfully submitted
        $$epiforms(".spinner-form").on("formsSubmitted", function (data) {
            stopSpinnerBySelector(spinner, getSpinnerContainerSelector(data.target));
        });

        // formsSubmittedError
        $$epiforms(".spinner-form").on("formsSubmittedError", function (data) {
            stopSpinnerBySelector(spinner, getSpinnerContainerSelector(data.target));
        });
    });
}